import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import * as fromApp from '../../store/app';

import HomeView from './Home.view';

import { ISupplierUI } from 'app/models/specs/home';
import { ISupplier } from 'app/models/supplier';

interface PropsFromState {
  backgroundImages: ISupplierUI;
  backgroundShadow: boolean;
  reviewes: boolean;
  supplier: ISupplier | null;
}

interface Props extends PropsFromState { }

const Home: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const backgroundImage: string = useMemo(() => {
    const supplier = props.supplier?.name || 'default';

    const backgroundImage = props.backgroundImages?.[supplier]?.backgroundImage;

    if (!backgroundImage) {
      return props.backgroundImages?.['default'].backgroundImage;
    }

    return backgroundImage;
  }, [props.backgroundImages, props.supplier?.name]);

  const footerLogo: string | null = useMemo(() => {
    const supplier = props.supplier?.name || 'default';

    const foolerImage = props.backgroundImages?.[supplier]?.footerImage;

    if (!foolerImage) {
      return props.backgroundImages?.['default'].footerImage;
    }

    return foolerImage;
  }, [props.backgroundImages, props.supplier?.name]);

  const topRightLogo: string | null = useMemo(() => {
    const supplier = props.supplier?.name || 'default';

    const topRightImage = props.backgroundImages?.[supplier]?.topRightImage;

    if (!topRightImage) {
      return props.backgroundImages?.['default'].topRightImage;
    }

    return topRightImage;
  }, [props.backgroundImages, props.supplier?.name]);

  return (
    <HomeView
      backgroundImage={backgroundImage}
      backgroundShadow={props.backgroundShadow}
      reviewes={props.reviewes}
      topRightLogo={topRightLogo}
      footerLogo={footerLogo}
    >
      {props.children}
    </HomeView>
  );
};

Home.displayName = 'Home';
Home.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState): PropsFromState => {
  return {
    backgroundImages: state.settings.specs!.pages.home.suppliersUI,
    backgroundShadow: state.settings.specs?.pages.home.backgroundShadow || false,
    reviewes: !!state.settings.specs?.pages.home.reviewes,
    supplier: state.settings.supplierDetails,
  };
};

export default connect(mapStateToProps)(Home);
